import {AfterViewInit, Component, ElementRef, inject, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {environment} from '@environments/environment';
import {Action, LiveboardEmbed} from "@thoughtspot/visual-embed-sdk";
import {ThoughtspotService} from "@app/_services/thoughtspot.service";

@Component({
    selector: 'app-dashboard',
    imports: [],
    templateUrl: './dashboard.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit, AfterViewInit {
    @ViewChild("liveboard") liveboard!: ElementRef;
    protected readonly environment = environment;
    private thoughtspotService = inject(ThoughtspotService);

    ngOnInit(): void {
        this.thoughtspotService.initEmbedSDK();
    }

    ngAfterViewInit(): void {
        this.renderLiveboard();
    }

    private renderLiveboard() {
        const visibleActions = [
            Action.Download,
            Action.CopyToClipboard,
            Action.DownloadAsPng,
            Action.DownloadAsCsv,
            Action.DownloadAsXlsx,
            Action.DrillDown,
            Action.Explore,
            Action.ShowUnderlyingData,
        ];

        const liveboardEmbed = new LiveboardEmbed(this.liveboard.nativeElement, {
            liveboardV2: true,
            liveboardId: environment.thoughtSpotConfig.pinnedVisualizationId,
            hideLiveboardHeader: false,
            hideTabPanel: false,
            linkOverride: true,

            frameParams: {
                width: "100%",
                height: "100%"
            },
            visibleActions: visibleActions
        });

        liveboardEmbed.render().then();
    }
}
